import {
  adjust,
  always,
  compose,
  concat,
  curry,
  dropLast,
  identity,
  ifElse,
  isEmpty,
  isNil,
  join,
  replace,
  reverse,
  split,
  splitEvery,
  trim,
} from 'ramda'

const toFixed = curry((n, num) => ifElse(
  isNaN, always(NaN),
  (num) => num.toFixed(n)
)(parseFloat(num)));
const notEmpty = ifElse(
  isEmpty,
  always(''),
  identity
);

const isMillion = (numStr) => {
  const [n] = numStr.split('.');
  return (n.length >= 7);
};

const parseMillion = (numStr) => {
  const [n] = numStr.split('.');
  const res = compose(
    reverse,
    ([t, ...h]) => `${t}.${join(' ', h)}`,
    splitEvery(3),
    reverse,
    dropLast(3)
  )(n);
  return concat(res, ' мил.')
};

export default {
  methods: {
    $priceFormatToFixed: toFixed,
    /**
     * Форматирует ввод цены
     * @param {String} str - цена
     * @return {String}
     */
    priceFormat(str) {
      return compose(
        notEmpty,
        (strNum) => {
          let [h, t] = split('.', strNum);
          if (isNil(t)) return h;
          return compose(
            concat(h),
            concat('.')
          )(t.slice(0, 2))
        },
        replace(/,/, '.'),
        replace(/[a-zа-яё_]/, ''),
        trim,
        (n) => `${n}`
      )(str);
    },

    /**
     * Форматирует вывод цены
     * @param {Number} num - цена
     * @param {Boolean} hideChange - скрыть мелочь
     * @return {String}
     */
    priceDisplay(num, hideChange = true, fix = 2) {

      return ifElse(
        isNaN,
        always('NaN'),
        compose(
          join('.'),
          ifElse((a) => (a[1] === '00') || hideChange, dropLast(1), identity),
          adjust(0, this.$parseHead),
          split('.')
        )
      )(toFixed(fix, num));
    },
    /**
     * Форматирует вывод цены
     * @param {Number} num - цена
     * @return {String}
     */
    priceDisplayMil(num) {

      return ifElse(
        isNaN,
        always('NaN'),
        ifElse(
          isMillion,
          parseMillion,
          compose(
            join('.'),
            ifElse((a) => a[1] === '00', dropLast(1), identity),
            adjust(0, this.$parseHead),
            split('.')
          )
        )
      )(toFixed(2, num));
    },
    $hideChange(currencyCode) {
      return ['UZS', 'KZT', 'RUB'].includes(currencyCode)
    },
    $parseHead(num) {
      return compose(
        reverse,
        join(' '),
        splitEvery(3),
        reverse,
      )(num)
    }
  }
}
